import { IconButton } from "@mui/material";
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import styles from '../../ProductsRPDesigner.module.scss';
import { aligmnentElements } from "../../responsePage/rptemplate";

function CSAlignment({ components, handleAlignment, selectedComponentIndex }) {

  return (
    <>
      {aligmnentElements.map((el) => {
        if (components[selectedComponentIndex]?.[el.name] !== undefined) {
          return (
            <div
              id={el.name}
              key={el.name}
              className={styles["sec--products--rpdesigner--colors--element"]}
            >
              <div
                className={
                  styles["sec--products--rpdesigner--colors--element--left"]
                }
              >
                {el.label}
              </div>
              <div>
                <IconButton
                  id="start"
                  onClick={(e) => handleAlignment("start", el.name)}
                >
                  <FormatAlignLeftIcon />
                </IconButton>
                <IconButton
                  id="center"
                  onClick={(e) => handleAlignment("center", el.name)}
                >
                  <FormatAlignCenterIcon />
                </IconButton>
                <IconButton
                  id="end"
                  onClick={(e) => handleAlignment("end", el.name)}
                >
                  <FormatAlignRightIcon />
                </IconButton>
              </div>
            </div>
          );
        }
      })}
    </>
  );
}

export default CSAlignment;